import { render, staticRenderFns } from "./TransProgramSeniorsContent.vue?vue&type=template&id=6d5c0ff9"
import script from "./TransProgramSeniorsContent.vue?vue&type=script&lang=ts"
export * from "./TransProgramSeniorsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports